import { useSelector } from "react-redux";

const useMultisportPageId = () => {
  const storeConfig = useSelector((state) => state.app.storeConfig);

  return storeConfig?.page_generator_multisport_id;
};

export default useMultisportPageId;
